var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHandsetcall = function SvgHandsetcall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.5 16.8",
    style: {
      enableBackground: "new 0 0 12.5 16.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_4_add_popup",
    transform: "translate(-149.000000, -404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(24.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(101.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#fff",
    d: "M6,1.3C5.5,1.6,5.1,2.1,4.9,2.8l0,0L4.3,5.1C3,10.3,6.1,15.6,11.2,17l0,0l2.3,0.6 c0.6,0.2,1.3,0.1,1.8-0.2l0,0l0,0c0.1-0.1,0.3-0.2,0.4-0.3l0,0c0.3-0.3,0.6-0.7,0.7-1.2l0,0c0.3-1.3-0.4-2.6-1.7-3l0,0 l-2.3-0.6C9.8,11.7,8.3,9,9,6.4l0,0l0.6-2.3c0.3-1.3-0.4-2.6-1.7-3l0,0c-0.5-0.1-1-0.1-1.4,0l0,0C6.3,1.2,6.2,1.2,6,1.3 L6,1.3L6,1.3z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandsetcall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/handsetcall.6cd38548.svg";
export { ForwardRef as ReactComponent };